import React, { useState, useEffect, useRef } from 'react';
import {urlBase} from "../../config/Globals";

import loupe from "../../assets/images/loupe.svg";
import maison from "../../assets/images/maison-blanche.svg";
import picto_carte from "../../assets/images/picto-carte.svg";
import CommuneService from "../../service/CommuneSevice";



export const RechercheCalendrier = () => {

    const [inputValue, setInputValue] = useState('');
    const [isOpen, setIsOpen] = useState(false);
    const searchContainerRef = useRef(null);


    //trouver la commune
    const[communes, setCommunes] = useState([]);
    const[loadingCommunes, setLoadingCommunes] = useState(1);
    const searcCommune = async(txt) => {
        try {
            const data = await CommuneService.search(txt);
            setCommunes(data.rows);
            setLoadingCommunes(false);
        } catch (error) {

        }
    }
    const handleInputChange = (e) => {
        const value = e.target.value;
        //console.log(value);
        setInputValue(value);

        if (value.trim().length >= 3) {
            //rechercher
            searcCommune(value.trim());
            setIsOpen(true);
        } else {
            setIsOpen(false);
        }
    };
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (searchContainerRef.current && !searchContainerRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    return (
        <>
            <section className="pt-md-5 pb-md-5 d-flex align-items-center">
                <div className="bg-cover-2 d-none d-md-block"></div>
                <div className="container-md px-md-4 position-relative z-1">
                    <div className="row flex-column align-items-center justify-content-center">
                        <div className="col-12 col-lg-10 bg-marron pb-5 p-4 p-md-5">
                            <div className="col-12">
                                <nav aria-label="breadcrumb" className="mb-4">
                                    <ol className="custom-breadcrumb">
                                        <li className="breadcrumb-item-custom text-white">
                                            <a href={urlBase} className="breadcrumb-link-home">
                                                <img src={maison} alt="Accueil" className="breadcrumb-icon"/>
                                            </a>
                                        </li>
                                        <li className="breadcrumb-separator text-white">•</li>
                                        <li className="breadcrumb-item-custom  text-white active" aria-current="page">
                                            Calendrier de prospection, cartes et résultats
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                            <div className="col-12 d-flex gap-3 align-items-center">
                                <img className="col-12 img-fluid" style={{ width: 50 }} src={picto_carte} alt="Picto carte"/>
                                <h1 className="text-white display-6 fw-sb mb-0">Calendrier de prospection, cartes et résultats</h1>
                            </div>
                            <div className="col-12 mt-4 text-white">
                                <p>Découvrez la carte de votre commune avec la localisation des points de prélevements, les résultats de prospection...</p>
                            </div>
                            <div className="d-flex flex-grow-1 align-items-center justify-content-center gap-3">
                                <div className="col-12 col-lg-6 col-xxl-8">
                                    <div ref={searchContainerRef} className="input-group position-relative">
                                        {isOpen && (
                                            <div id="search-results-box" className="search-results-dropdown position-absolute top-100 start-0 w-100 p-3 shadow">
                                                <ul className="list-unstyled mb-0 d-flex flex-column gap-1">
                                                    {communes && communes.length > 0 ? (
                                                        communes.map((commune) => (
                                                            <li key={commune.id}>
                                                                <a href={urlBase + "calendrier-prospection/" + commune.id} className="search-result-item d-block text-decoration-none text-dark">

                                                                    <span className="fw-bold">{commune.nom} ({commune.numero_departement})</span>
                                                                    {commune.secteurs.length > 1 && (
                                                                        <span className="text-muted small"> ({commune.secteurs.length} secteurs)</span>
                                                                    )}
                                                                    {commune.secteurs.length > 1 && commune.secteurs.map((secteur) => (
                                                                        <span key={secteur.id || secteur.nom} className="d-block fst-italic text-secondary small">
                                                                            • {secteur.nom}
                                                                        </span>
                                                                    ))}
                                                                </a>
                                                            </li>
                                                        ))
                                                    ) : (
                                                        <li>Aucun résultat</li>
                                                    )}
                                                </ul>
                                            </div>
                                        )}
                                        <input
                                            type="text"
                                            id="commune-search-input"
                                            className="form-control rounded-pill ps-4 py-2 border-0"
                                            placeholder="Rechercher une commune"
                                            aria-label="Rechercher une commune"
                                            value={inputValue}
                                            onChange={handleInputChange}
                                        />
                                        <span
                                            className="input-group-text bg-white border-0 rounded-pill position-absolute end-0 top-50 translate-middle-y me-2 p-1"
                                            style={{zIndex: 5, cursor: 'pointer'}}>
                                            <img src={loupe} alt="Rechercher"/>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}